import { createSlice } from "@reduxjs/toolkit";
import { CatalogOperator } from "../models/operator";

const CatalogOperatorInitialState: {
  operators: CatalogOperator[] | null;
} = {
  operators: null,
};

export const CatalogOperatorReducer = createSlice({
  name: "__",
  initialState: CatalogOperatorInitialState,
  reducers: {
    setOperators(state, { payload }) {
      state.operators = payload;
    },
  },
});
